import { createSlider } from './common'

export function createNewsFeatureSlider() {
  const wrapper = '.news-feature-block .news-slider'
  const prevArrow = '.news-feature-block .nav-icon.prev'
  const nextArrow = '.news-feature-block .nav-icon.next'
  const options = {
    slideTransition: 'linear',
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    dots: true,
    customPaging: () => $('<span class="dot" />'),
  }
  createSlider({ wrapper, prevArrow, nextArrow, options })
}



// WEBPACK FOOTER //
// ./scripts/func/news-feature-slider.js